// /*
// Usage:
//   <skio-cart-upsell item='{{ item | json | escape }}' line='{{ forloop.index }}'></skio-cart-upsell>
//   <script src="{{ 'skio-cart-upsell.js' | asset_url }}" type="module"></script>

//   May want to include above module globally if element is used in cart drawer
// */

// import { LitElement, html, css } from 'https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js'

// const skioCartStyles = css`
//   .skio-cart-upsell {
//     margin-top: 10px;
//     width: 100%;
//     padding: 1rem;
//     background: transparent;
//     border: 1px solid black;
//     border-radius: 0.5rem;
//     cursor: pointer;
//     max-width: 100%;
//     appearance: none;
//     background: url(https://cdn.shopify.com/s/files/1/0866/7664/files/select-arrow-skio.png?v=1742807564);
//     background-size: 12px;
//     background-repeat: no-repeat;
//     background-position: center right 16px;
//     border: 1px solid rgba(103, 103, 103, 0.32);
//     border-radius: unset;
//     padding: 9px 24px;
//     color: #111314;
//     font-size: 14px;
//     font-style: normal;
//     font-weight: 400;
//     line-height: 140%;
//     background-position: center right 24px;
//     outline: none;
//   }

//   button.skio-cart-upgrade:before {
//     content: '' !important;
//     background-image: url(https://cdn.shopify.com/s/files/1/0866/7664/files/no-subscription-image.png?v=1743148873) !important;
//     display: block;
//     width: 12px;
//     height: 12px;
//     position: absolute;
//     background-repeat: no-repeat;
//     left: 0;
//     top: 3px;
//   }

//   button.skio-cart-upgrade.skio-button-active:before {
//     content: '' !important;
//     background-image: url(https://cdn.shopify.com/s/files/1/0866/7664/files/upgrade-to-subscription.png?v=1742807922) !important;
//     display: block;
//     width: 12px;
//     height: 12px;
//     position: absolute;
//     background-repeat: no-repeat;
//     left: 0;
//     top: 3px;
//   }

//   .skio-cart-upgrade {
//     position: relative;
//     padding-left: 18px !important;
//     text-align: left;
//     margin-top: 10px;
//     background: transparent !important;
//     color: #676767 !important;
//     border: 1px solid transparent !important;
//     outline: none;
//     cursor: pointer;
//     padding: 0;
//     width: auto;
//     border-radius: 0.5rem;
//     transition: color 0.25s, background-color 0.25s, border-color 0.25s;
//     font-size: 12px;
//     font-style: normal;
//     font-weight: 400;
//     line-height: 140%;
//   }

//   .skio-cart-upgrade strong {
//     font-weight: 500;
//   }

//   .skio-cart-upgrade:hover {
//     color: #886af6;
//     border-color: #886af6;
//     background: transparent;
//   }
// `

// export class SkioCartUpsell extends LitElement {
//   static styles = skioCartStyles

//   static properties = {
//     item: {
//       type: Object,
//       converter: (value) => {
//         try {
//           return typeof value === 'string' ? JSON.parse(value) : value;
//         } catch (e) {
//           console.error('Failed to parse item JSON:', e);
//           return null;
//         }
//       }
//     },
//     line: {
//       type: Number,
//       converter: (value) => {
//         const num = parseInt(value, 10);
//         // Convert from 0-based to 1-based index
//         return isNaN(num) ? null : num + 1;
//       }
//     },
//     product: { type: Object },
//     selectedVariant: { type: Object },
//     key: { type: String },
//     skioSellingPlanGroups: { type: Array },
//     availableSellingPlanGroups: { type: Array },
//     selectedSellingPlanGroup: { type: Object },
//     selectedSellingPlan: { type: Object },
//     discount_format: { type: String },
//     moneyFormatter: {},
//     currency: { type: String }
//   }

//   constructor() {
//     super()

//     this.item = null
//     this.line = null

//     this.product = null
//     this.selectedVariant = null

//     this.skioSellingPlanGroups = null
//     this.availableSellingPlanGroups = null

//     this.selectedSellingPlanGroup = null
//     this.selectedSellingPlan = null

//     this.discountFormat = 'percent'

//     this.currency = 'USD'
//     this.moneyFormatter = new Intl.NumberFormat('en-US', {
//       style: 'currency',
//       currency: this.currency,
//     })
//   }

//   connectedCallback() {
//     super.connectedCallback()
//   }

//   attributeChangedCallback(name, oldValue, newValue) {
//     super.attributeChangedCallback(name, oldValue, newValue)
//   }

//   upgradeButton = () => {
//     if (this.availableSellingPlanGroups?.length > 0) {
//       return html`
//         <button class="skio-cart-upgrade ${this.selectedSellingPlan ? 'skio-button-active' : ''}" type="button" @click=${() => this.selectSellingPlan(this.availableSellingPlanGroups[0].selected_selling_plan.id)}>
//           <span>Upgrade to Subscription:</span><br>
//           <strong>Free shipping & Save ${this.discount(this.availableSellingPlanGroups[0].selected_selling_plan).percent}</strong>
//         </button>
//       `
//     } else {
//       return html``
//     }
//   }

//   changeFrequency = () => {
//     //console.log("this.selectedSellingPlan", this.selectedSellingPlan);
//     return html`
//       <select class="skio-cart-upsell" skio-cart-upsell="${this.key}" @change=${e => this.selectSellingPlan(e.target.value)} style="${ !this.selectedSellingPlan ? 'display:none;':'' }">
//         ${!this.product.requires_selling_plan
//           ? html`
//               <optgroup label="One Time Purchase">
//                 <option value="">One-time</option>
//               </optgroup>
//             `
//           : ''}
//         ${this.availableSellingPlanGroups
//           ? this.availableSellingPlanGroups.map(
//               (group, index) =>
//                 html`
//                   <optgroup label="${group.name} (Save ${this.discount(group.selected_selling_plan).percent})">
//                     ${group
//                       ? group.selling_plans.map(selling_plan => html` <option value="${selling_plan.id}" .selected=${selling_plan.id == this.selectedSellingPlan?.id}>${selling_plan.name}</option> `)
//                       : ''}
//                   </optgroup>
//                 `
//             )
//           : ''}
//       </select>
//     `
//   }

//   render() {
//     if (!this.item || !this.product || !this.selectedVariant) return
//     return html`
//       <div>
//       ${this.upgradeButton()}
//       </div>
//       <div>
//       ${this.changeFrequency()}
//       </div>
//       `
//   }

//   updated = changed => {
//     if (changed.has('item') && this.item) {
//       this.fetchProduct(this.item.handle)
//     }

//     if (changed.has('product') && this.product) {
//       this.skioSellingPlanGroups = this.product.selling_plan_groups.filter(selling_plan_group => selling_plan_group.app_id === 'SKIO')

//       this.selectedVariant = this.product.variants.find(variant => variant.id == this.item.variant_id)

//       if (this.item.selling_plan_allocation) {
//         this.selectedSellingPlanGroup = this.skioSellingPlanGroups.find(group => group.selling_plans.find(selling_plan => selling_plan.id == this.item.selling_plan_allocation.selling_plan.id))
//         this.selectedSellingPlan = this.selectedSellingPlanGroup.selling_plans.find(selling_plan => selling_plan.id == this.item.selling_plan_allocation.selling_plan.id)
//       }
//     }

//     if (changed.has('selectedVariant') && this.selectedVariant) {
//       //update availableSellingPlanGroups based on skioSellingPlanGroups and selectedVariant.id
//       this.availableSellingPlanGroups = this.skioSellingPlanGroups.filter(selling_plan_group =>
//         selling_plan_group.selling_plans.some(selling_plan =>
//           this.selectedVariant.selling_plan_allocations.some(selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id)
//         )
//       )

//       //update selectedSellingPlan value
//       if (this.availableSellingPlanGroups.length) {
//         //update each group with a default selected_selling_plan

//         this.availableSellingPlanGroups.forEach(group => {
//           group.selected_selling_plan = group.selling_plans[0]
//         })
//       }
//     }

//     if (changed.has('selectedSellingPlan') && this.product) {
//       this.updateLineItem()
//     }
//   }

//   log = (...args) => {
//     args.unshift('%c[skio cart upsell]', 'color: #8770f2;')
//     //console.log.apply(console, args)
//   }

//   error = (...args) => {
//     args.unshift('%c [skio cart upsell]', 'color: #ff0000')
//     console.error.apply(console, args)
//   }

//   getSectionsToRender() {
//     return [
//       {
//         id: 'cart_form',
//         section: document.getElementById('cart_form').dataset.id,
//         selector: '.cart__item-list',
//       },
//     ]
//   }

//   getSectionInnerHTML(html, selector) {
//     return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML
//   }

//   updateLineItem() {
//     if (!this.line || !this.item) return
//     if (this.item.selling_plan_allocation?.selling_plan?.id == this.selectedSellingPlan?.id) return

//     let data

//     if (this.selectedSellingPlan) {
//       data = JSON.stringify({
//         line: this.line,
//         quantity: this.item.quantity,
//         selling_plan: this.selectedSellingPlan ? this.selectedSellingPlan?.id : null,
//         properties: {
//           'Subscription Discount': this.discount(this.selectedSellingPlan).percent,
//         },
//       })
//     } else {
//       data = JSON.stringify({
//         line: this.line,
//         quantity: this.item.quantity,
//         selling_plan: null,
//         properties: {
//           'Subscription Discount': null,
//         },
//       })
//     }

//     fetch('/cart/change.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: data,
//     })
//       .then(response => response.text())
//       .then(cart => {
//         if (Shopify.theme.jsCart !== 'undefined' && window.location.href.includes('/cart')) {
//           Shopify.theme.jsCart.updateView(JSON.parse(cart), this.line)
//         }

//         if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
//           Shopify.theme.jsAjaxCart.updateView()
//         }

//         // Open cart menu after successful update
//         if (typeof openCartMenu === 'function') {
//           openCartMenu()
//         }
//       })
//   }

//   // Update selected selling plan group; called on click of skio-group-container element
//   selectSellingPlanGroup(group) {
//     this.selectedSellingPlanGroup = group
//     this.selectedSellingPlan = group?.selected_selling_plan
//   }

//   // Update selected selling plan; called on change of skio-frequency select element
//   selectSellingPlan(id) {
//     if (!id) {
//       this.selectedSellingPlanGroup = null
//       this.selectedSellingPlan = null
//       return
//     }

//     let group = this.availableSellingPlanGroups.find(group => group.selling_plans.find(selling_plan => selling_plan.id == id))
//     let selling_plan = group.selling_plans.find(x => x.id == id)

//     if (selling_plan) {
//       group.selected_selling_plan = selling_plan
//       this.selectedSellingPlanGroup = group
//       this.selectedSellingPlan = selling_plan
//     } else this.log("Error: couldn't find selling plan with id " + element.value + ' for variant ' + this.selectedVariant.id + ' from product ' + this.product.id + ' : ' + this.product.handle)
//   }

//   // Formats integer value into money value
//   money(price) {
//     return this.moneyFormatter.format(price / 100.0)
//   }

//   // Calculates discount based on selling_plan.price_adjustments, returns { percent, amount } of selling plan discount
//   discount(selling_plan) {
//     if (!selling_plan) return { percent: '0%', amount: 0 }

//     const price_adjustment = selling_plan.price_adjustments[0]
//     const discount = { percent: '0%', amount: 0 }
//     const price = this.selectedVariant.price

//     switch (price_adjustment.value_type) {
//       case 'percentage':
//         discount.percent = `${price_adjustment.value}%`
//         discount.amount = Math.round((price * price_adjustment.value) / 100.0)
//         break
//       case 'fixed_amount':
//         discount.percent = `${Math.round(((price_adjustment.value * 1.0) / price) * 100.0)}%`
//         discount.amount = price_adjustment.value
//         break
//       case 'price':
//         discount.percent = `${Math.round((((price - price_adjustment.value) * 1.0) / price) * 100.0)}%`
//         discount.amount = price - price_adjustment.value
//         break
//     }

//     return discount
//   }

//   fetchProduct = async handle => {
//     let productCache = window.sessionStorage.skioCartProductCache ? JSON.parse(window.sessionStorage.skioCartProductCache) : []
//     let cachedProduct = productCache ? productCache.find(product => product.handle == handle) : null

//     if (cachedProduct) {
//       this.product = cachedProduct
//     } else {
//       await fetch(`/products/${handle}.js`)
//         .then(response => response.json())
//         .then(response => {
//           this.product = response
//           productCache.push(response)
//           window.sessionStorage.skioCartProductCache = JSON.stringify(productCache)
//           this.requestUpdate()
//         })
//     }
//   }
// }

// customElements.define('skio-cart-upsell', SkioCartUpsell)

/*
Usage:
  <skio-cart-upsell item='{{ item | json | escape }}' line='{{ forloop.index0 }}'></skio-cart-upsell>
  <script src="{{ 'skio-cart-upsell.js' | asset_url }}" type="module"></script>

  Note: the `line` converter below adds 1, so pass forloop.index0 (0-based).
  May want to include above module globally if element is used in cart drawer
*/

import { LitElement, html, css } from 'https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js';

// Hard-coded plans per product: { productId: [{ id, label }] }
// Only plans that are allocated to the cart line's variant will be shown.
const PRODUCT_PLAN_OVERRIDES = {
  '4844480954461': [
    { id: '8302329949', label: 'Every 60 days' },
    { id: '1706524765', label: 'Every 30 days' },
  ],
};

const skioCartStyles = css`
  .skio-cart-upsell {
    margin-top: 8px;
    width: 100%;
    padding: 1rem 35px 1rem 22px !important;
    position: relative !important;
    background: transparent;
    border: 1px solid black;
    border-radius: 0.5rem;
    cursor: pointer;
    max-width: fit-content;
    appearance: none;
    background: url(https://cdn.shopify.com/s/files/1/0866/7664/files/select-arrow-skio.png?v=1742807564);
    background-size: 12px;
    background-repeat: no-repeat;
    background-position: center right 16px;
    border: 1px solid rgba(103, 103, 103, 0.32);
    border-radius: unset;
    padding: 9px 24px;
    color: #111314;
    font-family: var(--sb-font-family-body);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    background-position: center right 24px;
    outline: none;
  }

  optgroup[label='One Time Purchase'],
  optgroup[label='One Time Purchase'] option {
    display: none;
  }

  button.skio-cart-upgrade:before {
    content: '' !important;
    background-image: url(https://cdn.shopify.com/s/files/1/0866/7664/files/no-subscription-image.png?v=1743148873) !important;
    display: block;
    width: 12px;
    height: 12px;
    position: absolute;
    background-repeat: no-repeat;
    left: 0;
    top: 3px;
  }

  button.skio-cart-upgrade.skio-button-active:before {
    content: '' !important;
    background-image: url(https://cdn.shopify.com/s/files/1/0866/7664/files/upgrade-to-subscription.png?v=1742807922) !important;
    display: block;
    width: 12px;
    height: 12px;
    position: absolute;
    background-repeat: no-repeat;
    left: 0;
    top: 3px;
  }

  .skio-cart-upgrade {
    position: relative;
    padding-left: 18px !important;
    text-align: left;
    background: transparent !important;
    color: #676767 !important;
    border: 1px solid transparent !important;
    outline: none;
    cursor: pointer;
    padding: 0;
    width: auto;
    border-radius: 0.5rem;
    transition: color 0.25s, background-color 0.25s, border-color 0.25s;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    font-family: var(--sb-font-family-body);
  }

  .disable_cart_inputs .skio-cart-upgrade {
    cursor: wait;
  }

  .skio-cart-upgrade strong {
    font-weight: 500;
  }

  .skio-cart-upgrade:hover {
    color: #886af6;
    border-color: #886af6;
    background: transparent;
  }

  .sb-cart-drawer__item-subscription--requires-plan .skio-cart-upgrade,
  .skio-cart-upgrade.disabled {
    pointer-events: none;
    opacity: 0.5;
  }
`;

export class SkioCartUpsell extends LitElement {
  static styles = skioCartStyles;

  static properties = {
    item: {
      type: Object,
      converter: (value) => {
        try {
          return typeof value === 'string' ? JSON.parse(value) : value;
        } catch (e) {
          console.error('Failed to parse item JSON:', e);
          return null;
        }
      },
    },
    line: {
      type: Number,
      converter: (value) => {
        const num = parseInt(value, 10);
        // Convert from 0-based to 1-based index
        return isNaN(num) ? null : num + 1;
      },
    },
    product: { type: Object },
    selectedVariant: { type: Object },
    key: { type: String },
    skioSellingPlanGroups: { type: Array },
    availableSellingPlanGroups: { type: Array },
    selectedSellingPlanGroup: { type: Object },
    selectedSellingPlan: { type: Object },
    discount_format: { type: String },
    moneyFormatter: {},
    currency: { type: String },
  };

  constructor() {
    super();

    this.item = null;
    this.line = null;

    this.product = null;
    this.selectedVariant = null;

    this.skioSellingPlanGroups = null;
    this.availableSellingPlanGroups = null;

    this.selectedSellingPlanGroup = null;
    this.selectedSellingPlan = null;

    this.discountFormat = 'percent';

    this.currency = 'USD';
    this.moneyFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: this.currency,
    });
  }

  connectedCallback() {
    super.connectedCallback();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
  }

  // True if this cart line's variant is allowed to use the given selling plan
  isPlanAllowedForVariant = (planId) =>
    this.selectedVariant?.selling_plan_allocations?.some((a) => a.selling_plan_id == planId) ?? false;

  // For hard-coded products: the listed plans (in list order) that this variant can use.
  // Returns null when the product has no override.
  getOverridePlans = (group) => {
    const overrides = PRODUCT_PLAN_OVERRIDES[String(this.product?.id)];
    if (!overrides || !group) return null;
    return overrides
      .map((o) =>
        group.selling_plans.find((p) => String(p.id) === o.id && this.isPlanAllowedForVariant(p.id))
      )
      .filter(Boolean);
  };

  upgradeButton = () => {
    if (this.availableSellingPlanGroups?.length > 0) {
      const lineItem = this.closest('.cart--line-item');
      const btnDisabled =
        lineItem?.dataset.lineGiftProduct == 'yes' || this.classList.contains('skio-cart-upsell--requires-plan');

      // Discount of the selected plan, or of the group's default plan
      const discountPercent = this.selectedSellingPlan
        ? this.discount(this.selectedSellingPlan)?.percent || '0%'
        : this.discount(this.availableSellingPlanGroups[0].selected_selling_plan)?.percent || '0%';

      return html`
        <button
          class="skio-cart-upgrade ${this.selectedSellingPlan ? 'skio-button-active' : ''} ${btnDisabled
            ? 'disabled'
            : ''}"
          type="button"
          @click=${this.handleUpgradeClick}
        >
          <span>Upgrade to Subscription:</span><br />
          <strong>Free shipping & Save ${discountPercent}</strong>
        </button>
      `;
    }
    return html``;
  };

  handleUpgradeClick = () => {
    // Active subscription → switch back to one-time purchase
    if (this.selectedSellingPlan) {
      this.selectSellingPlan(null);
      return;
    }

    const group = this.availableSellingPlanGroups[0];
    const overridePlans = this.getOverridePlans(group);
    let preferred;

    if (overridePlans) {
      // Hard-coded product: only pick from the listed plans for this variant
      preferred =
        overridePlans.find((p) => p.name.toLowerCase().includes('every 30 days')) || overridePlans[0];
    } else {
      // Other products: only consider plans this variant can actually use
      const plans = group.selling_plans.filter((p) => this.isPlanAllowedForVariant(p.id));
      preferred =
        plans.find((p) => p.name.toLowerCase().includes('every 30 days')) ||
        plans.find((p) => p.name.toLowerCase().includes('30 days')) ||
        plans[0];
    }

    if (preferred) this.selectSellingPlan(preferred.id);
  };

  changeFrequency = () => {
    const overridePlans = PRODUCT_PLAN_OVERRIDES[String(this.product.id)];
    const selectedId = this.selectedSellingPlan?.id;

    // Renders the options for one group
    const renderPlans = (group) => {
      // ── Hard-coded product: show only listed plans allowed for this variant ──
      if (overridePlans) {
        const options = this.getOverridePlans(group).map((plan) => ({
          plan,
          label: overridePlans.find((o) => o.id === String(plan.id)).label,
        }));

        // Keep the cart line's current plan visible if it's not in the list
        const selectedPlan = group.selling_plans.find((p) => p.id == selectedId);
        if (selectedPlan && !options.some((o) => o.plan.id == selectedId)) {
          options.push({ plan: selectedPlan, label: selectedPlan.name });
        }

        return options.map(
          ({ plan, label }) => html`
            <option value="${plan.id}" .selected=${plan.id == selectedId}>${label}</option>
          `
        );
      }

      // ── All other products: existing rules ──
      // Does this variant have any "Every ..." plan in this group?
      // If not (e.g. plans are just "15 days", "30 days"...), plain plans are shown.
      const variantHasEveryPlan = group.selling_plans.some(
        (p) => this.isPlanAllowedForVariant(p.id) && p.name.toLowerCase().includes('every')
      );

      return group.selling_plans.map((selling_plan) => {
        const isSelected = selling_plan.id == selectedId;

        // Skip plans this variant can't use (unless already selected)
        if (!this.isPlanAllowedForVariant(selling_plan.id) && !isSelected) return '';

        const isSelectedCountPlan = this.selectedSellingPlan?.name.toLowerCase().includes('count');
        const hasCountInName = selling_plan.name.toLowerCase().includes('count');
        const hasEveryInName = selling_plan.name.toLowerCase().includes('every');

        // Rule 1: selected plan is a "count" plan → show only count plans
        if (isSelectedCountPlan) {
          if (hasCountInName) {
            return html`
              <option value="${selling_plan.id}" .selected=${isSelected}>${selling_plan.name}</option>
              ${isSelected
                ? html`
                    <select @change=${(e) => this.handleCountChange(e.target.value, selling_plan.id)}>
                      ${Array.from({ length: 10 }, (_, i) => i + 1).map(
                        (count) => html`<option value="${count}">${count}</option>`
                      )}
                    </select>
                  `
                : ''}
            `;
          }
          return '';
        }

        // Rule 2: plan has "Every" → show
        if (hasEveryInName) {
          return html`<option value="${selling_plan.id}" .selected=${isSelected}>${selling_plan.name}</option>`;
        }

        // Rule 3: no "Every" in name
        //  - variant has no "Every" plans at all → show (unless it's a "count" plan)
        //  - variant has "Every" plans → hide, unless it's the selected plan
        if (!variantHasEveryPlan && !hasCountInName) {
          return html`<option value="${selling_plan.id}" .selected=${isSelected}>${selling_plan.name}</option>`;
        }

        if (isSelected) {
          return html`<option value="${selling_plan.id}" .selected=${true}>${selling_plan.name}</option>`;
        }

        return '';
      });
    };

    return html`
      <select
        class="skio-cart-upsell"
        skio-cart-upsell="${this.key}"
        @change=${(e) => this.selectSellingPlan(e.target.value)}
        style="${!this.selectedSellingPlan ? 'display:none;' : ''}"
      >
        ${!this.product.requires_selling_plan
          ? html`
              <optgroup label="One Time Purchase">
                <option value="">One-time</option>
              </optgroup>
            `
          : ''}
        ${(this.availableSellingPlanGroups || []).map(
          (group) => html`
            <optgroup label="${group.name} (Save ${this.discount(group.selected_selling_plan).percent})">
              ${renderPlans(group)}
            </optgroup>
          `
        )}
      </select>
    `;
  };

  // Handler for count changes
  handleCountChange = (count, planId) => {
    // Implement your count change logic here
    console.log(`Count changed to ${count} for plan ${planId}`);
  };

  render() {
    if (!this.item || !this.product || !this.selectedVariant) return;
    return html`
      <div>${this.upgradeButton()}</div>
      <div>${this.changeFrequency()}</div>
    `;
  }

  updated = (changed) => {
    if (changed.has('item') && this.item) {
      this.fetchProduct(this.item.handle);
    }

    if (changed.has('product') && this.product) {
      this.skioSellingPlanGroups = this.product.selling_plan_groups.filter(
        (selling_plan_group) => selling_plan_group.app_id === 'SKIO'
      );

      this.selectedVariant = this.product.variants.find((variant) => variant.id == this.item.variant_id);

      if (this.item.selling_plan_allocation) {
        const cartPlanId = this.item.selling_plan_allocation.selling_plan.id;
        this.selectedSellingPlanGroup = this.skioSellingPlanGroups.find((group) =>
          group.selling_plans.some((selling_plan) => selling_plan.id == cartPlanId)
        );
        this.selectedSellingPlan =
          this.selectedSellingPlanGroup?.selling_plans.find((selling_plan) => selling_plan.id == cartPlanId) ||
          null;
      } else {
        this.selectedSellingPlanGroup = null;
        this.selectedSellingPlan = null;
      }
    }

    if (changed.has('selectedVariant') && this.selectedVariant) {
      // Groups that have at least one plan allocated to this variant
      this.availableSellingPlanGroups = this.skioSellingPlanGroups.filter((selling_plan_group) =>
        selling_plan_group.selling_plans.some((selling_plan) => this.isPlanAllowedForVariant(selling_plan.id))
      );

      // Default plan per group = first plan this variant can use
      this.availableSellingPlanGroups.forEach((group) => {
        const overridePlans = this.getOverridePlans(group);
        group.selected_selling_plan =
          overridePlans?.[0] ||
          group.selling_plans.find((p) => this.isPlanAllowedForVariant(p.id)) ||
          group.selling_plans[0];
      });
    }

    if (changed.has('selectedSellingPlan') && this.product) {
      this.updateLineItem();
    }
  };

  log = (...args) => {
    args.unshift('%c[skio cart upsell]', 'color: #8770f2;');
    // console.log.apply(console, args)
  };

  error = (...args) => {
    args.unshift('%c [skio cart upsell]', 'color: #ff0000');
    console.error.apply(console, args);
  };

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  updateLineItem() {
    if (!this.line || !this.item) return;
    if (this.item.selling_plan_allocation?.selling_plan?.id == this.selectedSellingPlan?.id) return;

    // Safety net: never send a plan this variant can't use
    if (this.selectedSellingPlan && !this.isPlanAllowedForVariant(this.selectedSellingPlan.id)) {
      this.error(
        `Plan ${this.selectedSellingPlan.id} is not allocated to variant ${this.selectedVariant?.id}; skipping update.`
      );
      this.resetToCartPlan();
      return;
    }

    document.body.classList.add('disable_cart_inputs');

    let data;
    let quantity = this.item.quantity; // Default quantity

    // Extract count from selling plan name if it contains "count"
    if (this.selectedSellingPlan?.name?.toLowerCase().includes('count')) {
      const countMatch = this.selectedSellingPlan.name.match(/\d+/);
      if (countMatch) {
        quantity = parseInt(countMatch[0], 10);
      }
    }

    const sections = this.getSectionsToRender().map((section) => section.section);

    if (this.item.selling_plan_allocation?.selling_plan?.id) {
      const props = this.item.properties || {};
      const updatedProps = {};

      if (props.Discount) updatedProps['Discount'] = props.Discount;
      if (props._subscription_only) updatedProps['_subscription_only'] = props._subscription_only;

      data = JSON.stringify({
        line: this.line,
        quantity,
        selling_plan: this.selectedSellingPlan.id,
        properties: updatedProps,
        sections,
        sections_url: window.location.pathname,
      });
    } else {
      data = JSON.stringify({
        line: this.line,
        quantity,
        selling_plan: null,
        properties: {
          'Subscription Discount': null,
        },
        sections,
        sections_url: window.location.pathname,
      });
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: data,
    })
      .then(async (response) => {
        const state = await response.json();
        if (!response.ok) {
          // Shopify sends the reason in description/message
          throw new Error(state.description || state.message || `HTTP ${response.status}`);
        }
        return state;
      })
      .then((parsedState) => {
        // Keep this component in sync with the real cart
        const updatedItem = parsedState.items?.[this.line - 1];
        if (updatedItem) this.item = updatedItem;

        if (Shopify.theme?.jsCart && window.location.href.includes('/cart')) {
          Shopify.theme.jsCart.updateView(parsedState, this.line);
        }

        if (typeof Shopify.theme?.jsAjaxCart !== 'undefined') {
          Shopify.theme.jsAjaxCart.updateView();
        }

        // Open cart menu after successful update
        if (typeof openCartMenu === 'function') {
          openCartMenu();
        }

        // Store progress bar state before section replacement
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const progressBar = document.querySelector('.sb-progress-bar');
        if (progressBar && cartDrawerWrapper) {
          cartDrawerWrapper.dataset.prevThresholdMet = progressBar.dataset.thresholdMet || 'false';
        }

        // Update sections (skip safely if the drawer isn't on the page)
        this.getSectionsToRender().forEach((section) => {
          const container = document.getElementById(section.id);
          const sectionHtml = parsedState.sections?.[section.section];
          if (!container || !sectionHtml) return;
          const elementToReplace = container.querySelector(section.selector) || container;
          elementToReplace.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
        });

        // Check progress bar state transition after section replacement
        const newProgressBar = document.querySelector('.sb-progress-bar[data-threshold-met]');
        if (newProgressBar && cartDrawerWrapper) {
          const currentThresholdMet = newProgressBar.dataset.thresholdMet === 'true';
          const prevThresholdMet = cartDrawerWrapper.dataset.prevThresholdMet === 'true';

          if (!prevThresholdMet && currentThresholdMet) {
            const fillElement = newProgressBar.querySelector('.sb-progress-bar__fill');
            if (fillElement) {
              newProgressBar.classList.remove('sb-progress-bar--threshold-met');
              fillElement.offsetHeight; // force reflow
              newProgressBar.classList.add('sb-progress-bar--threshold-met', 'sb-progress-bar--just-filled');
            }
          }

          cartDrawerWrapper.dataset.prevThresholdMet = currentThresholdMet;
        }
      })
      .catch((error) => {
        console.error('Error updating cart:', error.message);
        // Put the dropdown back to the plan that's actually in the cart
        this.resetToCartPlan();
      })
      .finally(() => {
        setTimeout(() => document.body.classList.remove('disable_cart_inputs'), 1000);
      });
  }

  // Revert UI to whatever plan the cart line really has
  resetToCartPlan() {
    const cartPlanId = this.item?.selling_plan_allocation?.selling_plan?.id;
    if (!cartPlanId) {
      this.selectedSellingPlanGroup = null;
      this.selectedSellingPlan = null;
      return;
    }
    const group = (this.availableSellingPlanGroups || []).find((g) =>
      g.selling_plans.some((p) => p.id == cartPlanId)
    );
    this.selectedSellingPlanGroup = group || null;
    this.selectedSellingPlan = group?.selling_plans.find((p) => p.id == cartPlanId) || null;
  }

  // Update selected selling plan group; called on click of skio-group-container element
  selectSellingPlanGroup(group) {
    this.selectedSellingPlanGroup = group;
    this.selectedSellingPlan = group?.selected_selling_plan;
  }

  // Update selected selling plan; called on change of the frequency select element
  selectSellingPlan(id) {
    if (!id) {
      this.selectedSellingPlanGroup = null;
      this.selectedSellingPlan = null;
      return;
    }

    const group = (this.availableSellingPlanGroups || []).find((g) =>
      g.selling_plans.some((selling_plan) => selling_plan.id == id)
    );
    const selling_plan = group?.selling_plans.find((x) => x.id == id);

    if (selling_plan) {
      group.selected_selling_plan = selling_plan;
      this.selectedSellingPlanGroup = group;
      this.selectedSellingPlan = selling_plan;
    } else {
      this.log(
        "Error: couldn't find selling plan with id " +
          id +
          ' for variant ' +
          this.selectedVariant?.id +
          ' from product ' +
          this.product?.id +
          ' : ' +
          this.product?.handle
      );
    }
  }

  // Formats integer value into money value
  money(price) {
    return this.moneyFormatter.format(price / 100.0);
  }

  // Calculates discount based on selling_plan.price_adjustments, returns { percent, amount }
  discount(selling_plan) {
    if (!selling_plan || !selling_plan.price_adjustments?.length) return { percent: '0%', amount: 0 };

    const price_adjustment = selling_plan.price_adjustments[0];
    const discount = { percent: '0%', amount: 0 };
    const price = this.selectedVariant.price;

    switch (price_adjustment.value_type) {
      case 'percentage':
        discount.percent = `${price_adjustment.value}%`;
        discount.amount = Math.round((price * price_adjustment.value) / 100.0);
        break;
      case 'fixed_amount':
        discount.percent = `${Math.round(((price_adjustment.value * 1.0) / price) * 100.0)}%`;
        discount.amount = price_adjustment.value;
        break;
      case 'price':
        discount.percent = `${Math.round((((price - price_adjustment.value) * 1.0) / price) * 100.0)}%`;
        discount.amount = price - price_adjustment.value;
        break;
    }

    return discount;
  }

  fetchProduct = async (handle) => {
    let productCache = [];
    try {
      productCache = window.sessionStorage.skioCartProductCache
        ? JSON.parse(window.sessionStorage.skioCartProductCache)
        : [];
    } catch (e) {
      productCache = [];
    }

    const cachedProduct = productCache.find((product) => product.handle == handle);

    if (cachedProduct) {
      this.product = cachedProduct;
      return;
    }

    try {
      const response = await fetch(`/products/${handle}.js`);
      const product = await response.json();
      this.product = product;
      productCache.push(product);
      try {
        window.sessionStorage.skioCartProductCache = JSON.stringify(productCache);
      } catch (e) {
        // storage full or blocked; ignore
      }
      this.requestUpdate();
    } catch (e) {
      this.error('Failed to fetch product', handle, e);
    }
  };
}

customElements.define('skio-cart-upsell', SkioCartUpsell);